export const blockIconsSocialSentimentSatisfied = (
	<span className='material-symbols-outlined'>sentiment_satisfied</span>
);
